import { Buffer3384y49aj0pxr as Buffer } from './Buffer.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var RealBufferedSinkClass;
function RealBufferedSink() {
  if (RealBufferedSinkClass === VOID) {
    class $ {
      constructor(sink) {
        this.l40_1 = sink;
        this.m40_1 = false;
        this.n40_1 = new (Buffer())();
      }
      f3v(source, byteCount) {
        // Inline function 'okio.internal.commonWrite' call
        // Inline function 'kotlin.check' call
        if (!!this.m40_1) {
          var message = 'closed';
          throw IllegalStateException().o(toString(message));
        }
        this.n40_1.f3v(source, byteCount);
        this.o40();
        return Unit_instance;
      }
      p3z(byteString) {
        // Inline function 'okio.internal.commonWrite' call
        // Inline function 'kotlin.check' call
        if (!!this.m40_1) {
          var message = 'closed';
          throw IllegalStateException().o(toString(message));
        }
        this.n40_1.p3z(byteString);
        return this.o40();
      }
      r3z(string) {
        // Inline function 'okio.internal.commonWriteUtf8' call
        // Inline function 'kotlin.check' call
        if (!!this.m40_1) {
          var message = 'closed';
          throw IllegalStateException().o(toString(message));
        }
        this.n40_1.r3z(string);
        return this.o40();
      }
      s3z(string, beginIndex, endIndex) {
        // Inline function 'okio.internal.commonWriteUtf8' call
        // Inline function 'kotlin.check' call
        if (!!this.m40_1) {
          var message = 'closed';
          throw IllegalStateException().o(toString(message));
        }
        this.n40_1.s3z(string, beginIndex, endIndex);
        return this.o40();
      }
      t3z(b) {
        // Inline function 'okio.internal.commonWriteByte' call
        // Inline function 'kotlin.check' call
        if (!!this.m40_1) {
          var message = 'closed';
          throw IllegalStateException().o(toString(message));
        }
        this.n40_1.t3z(b);
        return this.o40();
      }
      o40() {
        // Inline function 'okio.internal.commonEmitCompleteSegments' call
        // Inline function 'kotlin.check' call
        if (!!this.m40_1) {
          var message = 'closed';
          throw IllegalStateException().o(toString(message));
        }
        var byteCount = this.n40_1.a3z();
        if (byteCount > 0n) {
          this.l40_1.f3v(this.n40_1, byteCount);
        }
        return this;
      }
      pc() {
        // Inline function 'okio.internal.commonFlush' call
        // Inline function 'kotlin.check' call
        if (!!this.m40_1) {
          var message = 'closed';
          throw IllegalStateException().o(toString(message));
        }
        if (this.n40_1.h3v_1 > 0n) {
          this.l40_1.f3v(this.n40_1, this.n40_1.h3v_1);
        }
        this.l40_1.pc();
        return Unit_instance;
      }
      m6() {
        var tmp$ret$0;
        $l$block: {
          // Inline function 'okio.internal.commonClose' call
          if (this.m40_1) {
            tmp$ret$0 = Unit_instance;
            break $l$block;
          }
          var thrown = null;
          try {
            if (this.n40_1.h3v_1 > 0n) {
              this.l40_1.f3v(this.n40_1, this.n40_1.h3v_1);
            }
          } catch ($p) {
            if ($p instanceof Error) {
              var e = $p;
              thrown = e;
            } else {
              throw $p;
            }
          }
          try {
            this.l40_1.m6();
          } catch ($p_0) {
            if ($p_0 instanceof Error) {
              var e_0 = $p_0;
              if (thrown == null)
                thrown = e_0;
            } else {
              throw $p_0;
            }
          }
          this.m40_1 = true;
          if (!(thrown == null))
            throw thrown;
          tmp$ret$0 = Unit_instance;
        }
        return tmp$ret$0;
      }
      toString() {
        // Inline function 'okio.internal.commonToString' call
        return 'buffer(' + toString(this.l40_1) + ')';
      }
    }
    initMetadataForClass($, 'RealBufferedSink');
    RealBufferedSinkClass = $;
  }
  return RealBufferedSinkClass;
}
//region block: exports
export {
  RealBufferedSink as RealBufferedSinkipqv3pv5gqfq,
};
//endregion

//# sourceMappingURL=RealBufferedSink.mjs.map
